<template>
  <div class="bar-button">
    <div class="bar-button__head">
      <div :class="iconHead"></div>
    </div>
    <div class="bar-button__content">
      <div class="bar-button__content_title">{{ title }}</div>
      <div v-if="hint" class="bar-button__content_hint">
        {{ hint }}
      </div>
    </div>
    <div class="bar-button__tail">
      <div :class="iconTail"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    iconHead: {
      type: String,
      required: true,
    },
    iconTail: {
      type: String,
      default: "i-arrow",
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-button {
  font-family: Roboto-Regular;
  position: relative;
  width: 100vw;
  height: 64px;
  display: flex;
  align-items: center;
  background-color: white;
  text-align: left;
  color: #4a4a4a;
  border-bottom: 1px solid #f0f0f0;

  &__head {
    height: 100%;
    min-width: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__content {
    min-width: 280px;

    &_hint {
      padding-top: 6px;
      font-size: 12px;
      line-height: 14px;
      width: inherit;
      height: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #a8a8a8;
    }
  }

  &__tail {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
